import { createFetchFetcher } from '@odin/huginn-client';
import { FeedbackGate } from '@odin/huginn-client/ui';
import { useContext } from 'react';
import { TokenContext } from '../../config/contexts';

const apiBase = `${process.env.REACT_APP_REST_API_ADDRESS}/api/feedback`;

// Bearer token read per request like aceContext; JWT, so no CSRF
export const huginnFetcher = createFetchFetcher({
    headers: () => {
        const accessToken = JSON.parse(localStorage.getItem('accessToken') || 'null');
        return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
    },
    csrf: () => null,
});

// The gate fails open and silently; 404 is huginn switched off (demo, eagle), asked on every route change
const logFailure = (error, phase) => {
    if (error.status !== 404) console.warn(`[feedback] ${phase} failed:`, error.status, error.detail);
};

// Always mounted, gated by `enabled`: swapping the gate in on login would remount the app below it
export default function RecurringFeedbackGate({ children }) {
    const token = useContext(TokenContext);
    const enabled = token.access.isValid() && Boolean(token.parse().user?.is_active);

    return (
        <FeedbackGate fetcher={huginnFetcher} apiBase={apiBase} enabled={enabled} onError={logFailure}>
            {children}
        </FeedbackGate>
    );
}
